export default __webpack_public_path__ + "static/media/ramda.57a3d178.svg";